/* eslint-disable */
import React from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {
  FaCashRegister,
  FaFileMedical,
  FaFileExcel,
  FaRegEdit,
  FaRegTrashAlt,
} from "react-icons/fa";

import SideBar from "./SideBar";
import { useEffect, useState } from "react";
// import { setList } from '../features/accountListSlice'
import CreateAccList from "../views/CreateAccList";
// import AccListUpdate from "../../../views/Finance/AccountList/AccListUpdate";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { Link, useNavigate } from "react-router-dom";
import HeaderName from "./HeaderName";
import { useDispatch, useSelector } from "react-redux";
import { API_URL } from "../../api";
import { TablePagination } from "@mui/material";
import buildParams from "../../utils/buildParams";
import { setLimit, setPage } from "../../redux/account/accountSlice";
import { EditIcon } from "lucide-react";

function AccountList() {
  const token = localStorage.getItem("token");
  const url = API_URL();
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const scroll = {
    height: "550px",
    overflowY: "scroll",
  };

  const [accountLists, setAccountLists] = useState([]);
  const [open, setOpen] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [searchList, setSearchList] = useState([]);
  const [showOri, setShowOri] = useState(true);
  const [totalAccount, setTotalAccount] = useState(0);
  const showDialog = () => setOpen(true);
  //const accountList = useSelector((state)=>state.accountName);
  // const dispatch = useDispatch();

  const filter = useSelector((state) => state.accountList);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleDelete = (val) => {
    const getDELETE = async () => {
      const res = await api
        .delete("accounting-list/" + val)
        .then((response) => {
          Swal.fire({
            title: "Success",
            text: "Successfully Deleted!",
            icon: "success",
            confirmButtonText: "OK",
          });

          setAccountLists(accountLists.filter((item) => item._id !== val));
        })

        .catch((error) => {
          Swal.fire({
            title: "Error",
            text: error.response.data.message,
            icon: "error",
            confirmButtonText: "CANCEL",
          });
        });
    };
    getDELETE();
  };

  const search = (name) => {
    if (name) {
      setSearchList(
        accountLists.filter(
          (el) =>
            el.code?.toLowerCase().includes(name.toLowerCase()) ||
            el.subHeader?.toLowerCase().includes(name.toLowerCase()) ||
            el.relatedType?.name?.toLowerCase().includes(name.toLowerCase()) ||
            el.relatedHeader?.name?.toLowerCase().includes(name.toLowerCase()),
        ),
      );
      setShowSearch(true);
      setShowOri(false);
    } else {
      setShowSearch(false);
      setShowOri(true);
    }

    // console.log(
    //   accountLists.filter(
    //     el =>
    //       el.subHeader == name ||
    //       el.relatedType.name == name ||
    //       el.relatedHeader.name == name
    //   ),
    //   'search'
    // )
  };
  const _export = React.useRef(null);
  const excelExport = () => {
    if (_export.current !== null) {
      _export.current.save();
    }
  };
  const [updateDialog, setUpdateDialog] = useState(false);
  const [id, setId] = useState("");
  const showUpdate = (val) => {
    setId(val);
    setUpdateDialog(true);
  };

  // const handleAdminChange = () =>
  // {
  //   setExpanded(!isExpanded);
  // }

  //   const handleAccChange = () => {
  //     setAccData(!isAccData);
  //   };

  useEffect(() => {
    const getAccountLists = async () => {
      const params = buildParams(filter);
      try {
        const res = await api.get("accounting-lists", {
          params: Object.keys(params).length > 0 ? params : undefined,
        });

        setAccountLists(res.data.list);

        setTotalAccount(res?.data?._metadata?.total_count ?? 0);
        // dispatch(setList("success"));
      } catch (err) {}
    };
    getAccountLists();
  }, [filter]);

  const handleRowsPerPageChange = (event) => {
    dispatch(setLimit(event.target.value));
    dispatch(setPage(1));
  };
  const handleOnChange = (event, page) => {
    dispatch(setPage(page + 1));
  };

  return (
    <>
      {/* <!-- end preloader --> */}
      {/* @include('sweet::alert') */}

      <div className="wrapper">
        {/* <!-- Content Wrapper. Contains page content --> */}
        <div>
          {/* <!-- Content Header (Page header) --> */}
          <div className="content-header">
            <div className="container-fluid px-2">
              <div className="row ">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item active fs-5">
                      Account List
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}
          <section class="content" style={{ paddingBottom: "1.5rem" }}>
            <div class="container-fluid px-4">
              {/* <!-- Small boxes (Stat box) --> */}

              <div class="row">
                <div class="col-12">
                  <div class="card">
                    <div class="card-header">
                      {/* <h3 class="card-title">Account List</h3> */}
                      <div className="row justify-content-between py-3">
                        <div>
                          <span className="float-left">
                            <input
                              type="search"
                              className="form-control rounded ml-1"
                              style={{ borderRadius: "12px" }}
                              id="search_code"
                              onChange={(e) => search(e.target.value)}
                              placeholder="Search"
                            />
                          </span>

                          <span className="float-right">
                            <button
                              type="button"
                              id=""
                              className="btn btn-sm btn-dark rounded-2"
                              data-toggle="modal"
                              data-target="#new_account"
                              onClick={showDialog}
                            >
                              <i class="fa fa-plus"></i>Add
                            </button>{" "}
                            &nbsp;
                            <button
                              type="button"
                              className="btn btn-sm btn-success rounded-2"
                              data-toggle="modal"
                              data-target="#new_account"
                              onClick={excelExport}
                            >
                              <FaFileExcel />
                              &nbsp; Export
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                    {/* <!-- /.card-header --> */}
                    <div class="card-body">
                      {/* Export data in Excel */}
                      <ExcelExport data={accountLists} ref={_export}>
                        <ExcelExportColumn
                          field=""
                          title="No"
                          locked={true}
                          width={30}
                        />
                        <ExcelExportColumn
                          field="code"
                          title="Code"
                          width={100}
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          CellOptions={{
                            textAlign: "center",
                          }}
                        />
                        <ExcelExportColumn
                          field="relatedType.name"
                          title="Account Type"
                          width={150}
                        />
                        <ExcelExportColumn
                          field="relatedHeader.name"
                          title="Header"
                          width={150}
                        />
                        <ExcelExportColumn
                          field="name"
                          title="Sub Heading"
                          width={250}
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          CellOptions={{
                            textAlign: "center",
                          }}
                        />
                        <ExcelExportColumn
                          field="amount"
                          title="Balance"
                          width={100}
                          className="text-center"
                        />
                        <ExcelExportColumn
                          field="relatedCurrency"
                          title="Currency"
                          width={100}
                        />
                        <ExcelExportColumn
                          field="accountNature"
                          title="Account Nature"
                          width={100}
                        />
                        <ExcelExportColumn
                          field="type"
                          title="Type"
                          width={100}
                        />
                      </ExcelExport>
                      {/* Export Data in Excel end */}
                      <div>
                        <table id="example1" class="table">
                          <thead class="bg-info">
                            <tr>
                              <th>No</th>
                              <th>Code</th>

                              <th>Account Type</th>
                              <th>Header</th>
                              <th>Sub Heading</th>
                              <th>Balance</th>
                              <th>Currency</th>
                              <th>Account Nature</th>
                              <th>Type</th>
                              {/* <th>Flag</th>
                            <th>Forward</th> */}
                              <th className="text-center">Action</th>
                            </tr>
                          </thead>
                          {showOri && (
                            <tbody className="">
                              {accountLists
                                .sort((a, b) => (a.code > b.code ? 1 : -1))
                                .map((accountList, i) => (
                                  <tr key={accountList._id}>
                                    <td>{++i}</td>
                                    <td>{accountList.code}</td>

                                    <td>
                                      {accountList.relatedType
                                        ? accountList.relatedType.name
                                        : ""}
                                    </td>
                                    <td>
                                      {accountList.relatedHeader
                                        ? accountList.relatedHeader.name
                                        : ""}
                                    </td>
                                    <td>{accountList.subHeader}</td>
                                    <td>{accountList.amount}</td>
                                    <td>{accountList.relatedCurrency}</td>
                                    <td>{accountList.accountNature}</td>
                                    <td>{accountList.type}</td>
                                    {/* <td>{accountList.generalFlag ? 'Yes' : 'No'}</td>
                              <td>{accountList.carryForWork ? 'Yes' : 'No'}</td> */}
                                    <td>
                                      <div className="row">
                                        <div className="col-md-4 d-flex justify-content-center">
                                          {/* <Link
                                            to={"/accUpdate/" + accountList._id}
                                            className=""
                                          >
                                            
                                          </Link> */}
                                          <button
                                            onClick={() =>
                                              navigate(
                                                `/accUpdate/${accountList._id}`,
                                              )
                                            }
                                            className="btn btn-warning btn-sm  text-white"
                                          >
                                            <EditIcon size={16} />
                                          </button>
                                        </div>
                                        &nbsp;&nbsp;
                                        <div className=" col-md-4">
                                          <button
                                            onClick={() =>
                                              handleDelete(accountList._id)
                                            }
                                            class="btn btn-danger btn-sm "
                                          >
                                            <FaRegTrashAlt />
                                          </button>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          )}
                          {showSearch && (
                            <tbody className="">
                              {searchList
                                .sort((a, b) => (a.code > b.code ? 1 : -1))
                                .map((accountList, i) => (
                                  <tr key={accountList._id}>
                                    <td>{++i}</td>
                                    <td>{accountList.code}</td>

                                    <td>
                                      {accountList.relatedType
                                        ? accountList.relatedType.name
                                        : ""}
                                    </td>
                                    <td>
                                      {accountList.relatedHeader
                                        ? accountList.relatedHeader.name
                                        : ""}
                                    </td>
                                    <td>{accountList.subHeader}</td>
                                    <td>{accountList.amount}</td>
                                    <td>{accountList.relatedCurrency}</td>
                                    <td>{accountList.accountNature}</td>
                                    <td>{accountList.type}</td>
                                    {/* <td>{accountList.generalFlag ? 'Yes' : 'No'}</td>
                              <td>{accountList.carryForWork ? 'Yes' : 'No'}</td> */}
                                    <td>
                                      <div className="row">
                                        <div className="col-md-4">
                                          <Link
                                            to={"/accUpdate/" + accountList._id}
                                            className="btn btn-warning btn-sm"
                                          >
                                            <FaRegEdit />
                                          </Link>
                                        </div>
                                        &nbsp;&nbsp;
                                        <div className=" col-md-4">
                                          <button
                                            onClick={() =>
                                              handleDelete(accountList._id)
                                            }
                                            class="btn btn-danger btn-sm "
                                          >
                                            <FaRegTrashAlt />
                                          </button>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          )}
                        </table>
                        <TablePagination
                          component="div"
                          count={totalAccount ?? 0}
                          page={filter?.page - 1 || 0}
                          onPageChange={handleOnChange}
                          rowsPerPage={filter?.limit || 10}
                          onRowsPerPageChange={handleRowsPerPageChange}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",

                            "& .MuiTablePagination-toolbar": {
                              display: "flex",
                              alignItems: "center",
                              minHeight: "52px",
                            },

                            "& .MuiTablePagination-selectLabel": {
                              margin: 0,
                              display: "flex",
                              alignItems: "center",
                            },

                            "& .MuiTablePagination-displayedRows": {
                              margin: 0,
                              display: "flex",
                              alignItems: "center",
                            },

                            "& .MuiTablePagination-actions": {
                              display: "flex",
                              alignItems: "center",
                            },
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <CreateAccList
                open={open}
                close={() => setOpen(false)}
                setOpen={setOpen}
                setAccountLists={setAccountLists}
                accountLists={accountLists}
              />
              {/* 
              <AccListUpdate
                updateDialog={updateDialog}
                close={() => setUpdateDialog(false)}
                setUpdateDialog={setUpdateDialog}
                id={id}
                setAccountLists={setAccountLists}
                accountLists={accountLists}
              /> */}

              {/* <!-- /.row (main row) --> */}
            </div>
          </section>
          {/* <!-- /.content --> */}
        </div>
      </div>

      {/* <!-- /.content-wrapper --> */}

      {/* <!-- Control Sidebar --> */}
      <aside className="control-sidebar control-sidebar-dark">
        {/* <!-- Control sidebar content goes here --> */}
      </aside>
      {/* <!-- /.control-sidebar --> */}
    </>
  );
}
export default AccountList;
